var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisneyLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15.1341,
    height: 7.87266,
    viewBox: "0 0 15.1341 7.87266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2423 4.96453V5.25883H11.338V7.42988H10.9712V5.25883H10.0712V4.96453H12.2423Z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5664 4.96453H13.0868L13.8545 7.046L14.618 4.96453H15.1341V7.42561H14.7886V5.97114C14.7886 5.91996 14.7886 5.83891 14.7886 5.72375C14.7886 5.60859 14.7886 5.48489 14.7886 5.3484L14.0252 7.42561H13.6669L12.8948 5.3484V5.42518C12.8948 5.48489 12.8949 5.57873 12.8991 5.70242C12.8991 5.82612 12.9034 5.91569 12.9034 5.9754V7.42988H12.5579V4.96879L12.5664 4.96453Z",
    fill: "#231815"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.49303 0.429679C7.63996 -0.171731 6.51819 -0.0480369 5.98929 0.702659C5.60115 1.25288 5.63954 1.98652 6.01915 2.57513C5.61394 2.34907 5.14902 2.22111 4.65424 2.22111C4.15947 2.22111 3.71588 2.34481 3.31494 2.55807C3.71162 1.96093 3.75853 1.2145 3.36185 0.65574C2.83295 -0.0992209 1.71118 -0.218649 0.858115 0.38276C0.0050522 0.984169 -0.25513 2.08036 0.273769 2.83532C0.734423 3.49217 1.64294 3.66705 2.43629 3.30877C2.06094 3.78648 1.83488 4.39216 1.83488 5.04902C1.83488 6.60586 3.09741 7.87266 4.65851 7.87266C6.21962 7.87266 7.48215 6.61012 7.48215 5.04902C7.48215 4.40922 7.26888 3.82061 6.90633 3.34716C7.69968 3.71824 8.62099 3.54336 9.08591 2.88224C9.61481 2.13154 9.35463 1.03109 8.50157 0.429679H8.49303Z",
    fill: "#231815"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisneyLogoBlack);
export default __webpack_public_path__ + "static/media/disneyLogoBlack.0868ea2b0f1fab9e980632f890088acd.svg";
export { ForwardRef as ReactComponent };